import type { FC } from 'react';
import EmbedYoutube from '../../utils/EmbedYoutube/EmbedYoutube';
import { ControlStatementsWrapper } from './ControlStatements.styled';
import controlStatements1 from './../../../resources/content/controlStatements1.png';

interface ControlStatementsProps {}

const ControlStatements: FC<ControlStatementsProps> = () => (
 <ControlStatementsWrapper>
   <header className="entry-header">
      <h1 className="entry-title" itemProp="headline">Control Statements</h1>			
   </header>
   <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
      <p className="text-align-justify">A control statement is a statement that determines whether other statements will be executed or not. It determines the flow of a program. It allows us to make decisions, perform a task repeatedly, or jump from one section of code to another.</p>
      <div>
         <figure className="aligncenter size-large is-resized">
            <img decoding="async" src={controlStatements1} data-lazy-type="image" alt="" className="reduced-img" />
         </figure>
      </div>
      <p className="text-align-justify">In this section of our training, we will be covering the following topics :</p>
      <ul className="text-align-justify">
         <li>If else &amp; switch statements</li>
         <li>Loops</li>
         <li>Break &amp; Continue Keywords</li>
      </ul>
      <br/>
      <EmbedYoutube videoType="video" videoList={["KkysGYu_YIU"]} />
   </div>
</ControlStatementsWrapper>
);

export default ControlStatements;
